// src/components/Forms/RadioButton.tsx
import { Radio } from 'antd';
import { RadioChangeEvent } from 'antd/es/radio';
import React from 'react';
type RadioButtonProps = {
  options: { label: string; value: string | number }[]; // Radio button options
  value?: string | number; // Selected value
  onChange?: (e: RadioChangeEvent) => void; // Change event handler
  disabled?: boolean; // Disable the radio group
  ariaLabel?: string; // Screen reader label for the group
  ariaDescribedby?: string; // Additional help text
};
const RadioButton: React.FC<RadioButtonProps> = ({
  options,
  value,
  onChange,
  disabled = false,
  ariaLabel,
  ariaDescribedby,
}) => {
  return (
<Radio.Group
      value={value}
      onChange={onChange}
      disabled={disabled}
      aria-label={ariaLabel} // Accessible label for the group
      aria-describedby={ariaDescribedby} // Links to help text
>
      {options.map((option) => (
<Radio key={option.value} value={option.value}>
          {option.label}
</Radio>
      ))}
</Radio.Group>
  );
};
export default RadioButton; 